import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-76bff4fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "animate container"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "heart-container"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Siguiendo", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Seguir", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Siguiendo", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Seguir", -1))
const _hoisted_14 = {
  key: 1,
  class: "spacer"
}

import CourseProgressbar from '@/components/widgets/CourseProgressbar.vue'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import CourseService from '@/services/CourseService'
import { onMounted, ref, Ref } from 'vue'
import { useRoute } from 'vue-router'
import LessonViewer from '@/components/sections/LessonViewer.vue'
import { useAuth } from '@/store/useAuth'
import FollowCourseService from '@/services/FollowCourseService'
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import AuthorService from '@/services/AuthorService'
import useWindowWidth from '@/composables/useWindowWidth'
import main from '@/data/main.js'
//import BookBar from '@/components/layouts/BookBar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseView',
  setup(__props) {

const { windowWidth } = useWindowWidth()
const store = useAuth()
const toast = useToast()
const follow = ref(false)
const followCourseService = new FollowCourseService()
const progressBar:Ref<any> = ref(null)
const loading = ref(true)
const heartLoading = ref(true)
const courseService = new CourseService()
const course = ref()
const route = useRoute()
const course_id = route.params.id
const authorService = new AuthorService()
const authorInfo = ref()

onMounted(async () => {
    loading.value = true
    course.value = await courseService.GetCourse(course_id)
    loading.value = false
    authorInfo.value = await authorService.GetAuthor(course.value.author_id)
    if (!store.token) {
        heartLoading.value = false
        return;
    }
    heartLoading.value = true
    follow.value = await followCourseService.checkFollowCourseStatus(store.token, course_id)
    heartLoading.value = false

})

const handleFollowCourse = async () => {
    if (!store.token) {
        return;
    }
    heartLoading.value = true
    const response = await followCourseService.doFollowToCourse(store.token, course_id)
    toast.showToast("Has comenzado a seguir el curso.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
    follow.value = true
    heartLoading.value = false
}

const handleUnfollowCourse = async () => {
    if (!store.token) {
        return;
    }
    heartLoading.value = true
    const response = await followCourseService.doUnfollowToCourse(store.token, course_id)
    toast.showToast("Has dejado de seguir el curso.", Toast.WARNING)
    setTimeout(function () { toast.hideToast() }, 4000);
    follow.value = false
    heartLoading.value = false
}

const refreshStatus = async () => {
    if (progressBar.value == null) {
        return
    }
        await progressBar.value.updateStatus()
   
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", null, _toDisplayString(course.value.name), 1),
              (heartLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_v_icon, {
                      name: "ri-loader-2-fill",
                      animation: "spin",
                      class: "icon",
                      scale: "2"
                    })
                  ]))
                : (_unref(store).token)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_unref(windowWidth) > 950)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (follow.value)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "button-follow-inner",
                                  onClick: handleUnfollowCourse
                                }, [
                                  _createVNode(_component_v_icon, {
                                    name: "bi-heart-fill",
                                    fill: _unref(main).THIRD_COLOR,
                                    hover: "true",
                                    animation: "wrench",
                                    class: "heart",
                                    scale: "1"
                                  }, null, 8, ["fill"]),
                                  _hoisted_7
                                ]))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "button-follow-inner",
                                  onClick: handleFollowCourse
                                }, [
                                  _createVNode(_component_v_icon, {
                                    name: "bi-heart-fill",
                                    fill: "#ccc",
                                    hover: "true",
                                    animation: "wrench",
                                    class: "heart",
                                    scale: "1"
                                  }),
                                  _hoisted_8
                                ]))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
            ]),
            _hoisted_9,
            _createVNode(CourseProgressbar, {
              "course-id": course.value.id,
              ref_key: "progressBar",
              ref: progressBar,
              class: "bar"
            }, null, 8, ["course-id"]),
            _hoisted_10,
            (_unref(windowWidth) <= 950)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (follow.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "button-follow-inner-mobile",
                        onClick: handleUnfollowCourse
                      }, [
                        _createVNode(_component_v_icon, {
                          name: "bi-heart-fill",
                          fill: _unref(main).THIRD_COLOR,
                          hover: "true",
                          animation: "wrench",
                          class: "heart",
                          scale: "1"
                        }, null, 8, ["fill"]),
                        _hoisted_12
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "button-follow-inner-mobile",
                        onClick: handleFollowCourse
                      }, [
                        _createVNode(_component_v_icon, {
                          name: "bi-heart-fill",
                          fill: "#ccc",
                          hover: "true",
                          animation: "wrench",
                          class: "heart",
                          scale: "1"
                        }),
                        _hoisted_13
                      ]))
                ]))
              : _createCommentVNode("", true),
            (_unref(windowWidth) <= 950)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14))
              : _createCommentVNode("", true),
            _createVNode(LessonViewer, {
              courseId: course.value.id,
              authorInfo: authorInfo.value,
              courseDescription: course.value.description,
              onRefreshStatus: refreshStatus
            }, null, 8, ["courseId", "authorInfo", "courseDescription"])
          ]))
    ]),
    _: 1
  }))
}
}

})